
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import NavHeader from "@/components/semantics/TempNavHeader.vue";
import Footer from "@/components/semantics/Footer.vue";
// import Footer from '@components/footer/Footer.vue';
@Component({
	name: "StationTemp",
	components: {
		NavHeader,
		Footer
	}
})
export default class StationTemp extends Vue {
	isOverflow: any = true;
	mounted() {
		const pcm = document.getElementById("pcm");
		// (pcm as any).
		(pcm as any).addEventListener("scroll", () => {
			this.isOverflow = false;
		});
	}
	@Watch("$route", { immediate: true })
	handleChange() {
		this.isOverflow = true;
	}
}
